module.exports = __webpack_public_path__ + "static/media/ic_sip.5bce1cc8.svg";